import Store from "@/shared/global-store";
import { Component, Vue } from "vue-property-decorator";

export enum StateMenu {
  fechado = 0,
  aberto = 1,
  mini = 2,
}
@Component
export default class GlobalMixin extends Vue {
  state = Store.state;

  /**
   * Alterar o estado do drawer menu
   *
   * Resolvido bug do estado mini quando é fechado via controller
   * @param state Estado que o menu será alterado
   */
  setMenuState(state: StateMenu) {
    //Só executar quando realmente houver mudança de estado
    if (this.state.drawer != state) {
      //Obter o menu lateral
      const navigator = document.querySelector("nav.v-navigation-drawer");
      //Se obtido com sucesso, registrar o evento mouseleave para mudar o state do drawer
      if (navigator) {
        const listener = () => {
          //Mudar o estado do drawer
          this.state.drawer = state;
          //Remover a escuta do evento
          navigator.removeEventListener("mouseleave", listener, false);
        };

        //Registra a escuta para efetivar o estado do drawer apenas quando o usuário tirar o hover do menu
        navigator.addEventListener("mouseleave", listener, false);
      } else this.state.drawer = state;
    }
  }
  startLoader() {
    Store.startLoader();
  }
  stopLoader() {
    Store.stopLoader();
  }
}
